module.exports = __webpack_public_path__ + "img/product_66.1a132d0.webp";